import React from 'react';
import { TimelineEntry } from '../types';
import { STATUS_LABELS } from '../constants/statuses';
import { CheckCircle2, Clock, Truck, Package, Home } from 'lucide-react';
interface OrderTimelineProps {
  timeline: TimelineEntry[];
}
export function OrderTimeline({
  timeline
}: OrderTimelineProps) {
  // Sort timeline by date descending (newest first)
  const sortedTimeline = [...timeline].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  const getIcon = (status: string) => {
    if (status.includes('LIVREE')) return <CheckCircle2 className="w-5 h-5 text-white" data-id="element-154" />;
    if (status.includes('TOURNEE')) return <Truck className="w-5 h-5 text-white" data-id="element-155" />;
    if (status.includes('DEPOT') || status.includes('STOCKEE')) return <Home className="w-5 h-5 text-white" data-id="element-156" />;
    if (status.includes('NETTOYAGE')) return <Package className="w-5 h-5 text-white" data-id="element-157" />;
    return <Clock className="w-5 h-5 text-white" data-id="element-158" />;
  };
  const getColor = (index: number) => {
    return index === 0 ? 'bg-blue-500' : 'bg-gray-400';
  };
  return <div className="flow-root" data-id="element-159">
      <ul className="-mb-8" data-id="element-160">
        {sortedTimeline.map((entry, idx) => <li key={idx} data-id="element-161">
            <div className="relative pb-8" data-id="element-162">
              {idx !== sortedTimeline.length - 1 ? <span className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" data-id="element-163" /> : null}
              <div className="relative flex space-x-3" data-id="element-164">
                <div data-id="element-165">
                  <span className={`h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white ${getColor(idx)}`} data-id="element-166">
                    {getIcon(entry.status)}
                  </span>
                </div>
                <div className="flex min-w-0 flex-1 justify-between space-x-4 pt-1.5" data-id="element-167">
                  <div data-id="element-168">
                    <p className="text-sm text-gray-500" data-id="element-169">
                      {entry.action}{' '}
                      <span className="font-medium text-gray-900" data-id="element-170">
                        ({STATUS_LABELS[entry.status]})
                      </span>
                    </p>
                    <p className="text-xs text-gray-400 mt-1" data-id="element-171">
                      Par: {entry.userName}
                    </p>
                  </div>
                  <div className="whitespace-nowrap text-right text-sm text-gray-500" data-id="element-172">
                    <time dateTime={entry.date} data-id="element-173">
                      {new Date(entry.date).toLocaleDateString('fr-FR', {
                    day: 'numeric',
                    month: 'short',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                    </time>
                  </div>
                </div>
              </div>
            </div>
          </li>)}
      </ul>
    </div>;
}